/**
 * WEBSITE TRAFFIC objective — Search campaigns optimised for relevant visits.
 * Pages in this folder: TrafficPage, TrafficCampaignWizard, CreateTrafficAdgroup, CreateTrafficAd.
 */
import { MousePointerClick } from 'lucide-react';
import { SearchObjectiveConfig } from '@/components/google-ads/search/searchShared';

export const TRAFFIC_BASE = '/google-ads/traffic';

export const TRAFFIC_OBJECTIVE: SearchObjectiveConfig = {
  key: 'traffic',
  title: 'Website traffic',
  base: TRAFFIC_BASE,
  subtitle: 'Search ads that bring the right people to your website',
  icon: MousePointerClick,
  leadForms: false,
  defaultBidding: 'MAXIMIZE_CLICKS',
  goal: 'Relevant visits to your website',
  emptyHint: 'Bring people who are searching for what you sell straight to your website.',
};
